export enum CurrencyCode {
  ETB = 'ETB',
  DEMO = 'DEMO'
}

export interface GameConfig {
  minStake: number;
  maxStake: number;
  maxWin: number;
}

export interface LaunchRequest {
  clientId: string;
  userId: string;
  userToken: string;
  username: string;
  currency: CurrencyCode;
}

export interface LaunchResponse {
  balance: number;
  currency: CurrencyCode;
  gameConfig: GameConfig;
  bets: BetDto[];
}

export interface PlaceBetRequest {
  clientId: string;
  userId: string;
  userToken: string;
  username: string;
  currency: CurrencyCode;
  stake: number;
  picks: number[];
}

export interface BetDto {
  id: string;
  grossStake: number;
  netWinning: number;
  status: 'PLACED' | 'WON' | 'LOST' | 'PAID';
  reels: number[][];
  winningLines: number[];
  winningSymbols: number[];
  linePayouts: LinePayout[];
  createdAt: string;
}

export interface LinePayout {
  lineIndex: number;
  symbol: number;
  count: number;
  payout: number;
}

export interface BetHistoryRequest {
  clientId: string;
  userId: string;
  userToken: string;
  page: number;
  limit: number;
}

export enum BetStatus {
  PLACED = 'PLACED',
  WON = 'WON',
  LOST = 'LOST',
  PAID = 'PAID'
}